const initState = {
  schoolLoading: false,
  athletes: [],
  athlete: {},
  singleFan: {},
  institutes: [],
  schoolStates: [],
  collegeStates: [],
  hsInstitutes: [],
  cities: [],
  counties: [],
  schools: [],
  schoolsById: [],
  schoolInstitutes: [],
  schoolInstitutesId: [],
  collegeInstitutes: [],
  collegeInstitutesId: [],
  schoolsAndColleges: [],
  allSchoolsAndCollages: [],
};
const athleteReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_ALL_SCHOOLS_AND_COLLAGES":
      return {
        ...state,
        allSchoolsAndCollages: action.payload,
      };
    case "ADD_SCHOOLS_LOADER":
      return {
        ...state,
        schoolLoading: action.payload,
      };
    case "GET_ATHLETES":
      return {
        ...state,
        athletes: action.payload,
      };
    case "GET_SINGLE_ATHLETE":
      return {
        ...state,
        athlete: action.payload,
      };
    case "GET_SINGLE_FAN":
      return {
        ...state,
        singleFan: action.payload,
      };
    case "GET_INSTITUTES":
      return {
        ...state,
        institutes: action.payload,
      };
    case "GET_HIGH_SCHOOL_INSTITUTES":
      return {
        ...state,
        hsInstitutes: action.payload,
      };
    case "GET_COLLEGE_STATES":
      return {
        ...state,
        collegeStates: action.payload,
      };
    case "GET_SCHOOL_STATES":
      return {
        ...state,
        schoolStates: action.payload,
      };
    case "GET_CITY_BY_STATE":
      return {
        ...state,
        cities: action.payload,
      };
    case "GET_COUNTY_BY_STATE":
      return {
        ...state,
        counties: action.payload,
      };
    case "NEW_SCHOOLSANDCOLLEGES":
      return {
        ...state,
        schoolsAndColleges: action.payload,
      };
    case "NEW_SCHOOLS":
      return {
        ...state,
        schoolInstitutes: action.payload,
      };
    case "NEW_COLLEGE_UNIVERSITIES":
      return {
        ...state,
        collegeInstitutes: action.payload,
      };
    case "GET_NEW_COLLEGE_BY_ID":
      return {
        ...state,
        collegeInstitutesId: action.payload,
      };
    case "GET_NEW_SCHOOLS_BY_ID":
      return {
        ...state,
        schoolInstitutesId: action.payload,
      };
    case "GET_SCHOOLS":
      return {
        ...state,
        schools: action.payload,
      };
    case "GET_SCHOOLS_BY_ID":
      return {
        ...state,
        schoolsById: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export default athleteReducer;
